module.exports = __webpack_public_path__ + "img/roll-dough-top-down.301e94ee.svg";